import { useState } from "react";

const useChangeYear = () => {
  const [year, setYear] = useState<number>(new Date().getFullYear());

  const handleChangeYear = (effect: "default" | "increase" | "decrease", dateT?: Date) => {
    if (effect === "increase") setYear(year + 1);
    if (effect === "decrease") setYear(year - 1);
    if (effect === "default" && dateT) setYear(dateT.getFullYear());
  };

  return { year, handleChangeYear };
};

export default useChangeYear;
